export function PlusIcon({
  width = 15,
  height = 14,
  className = '',
  color = 'black',
}: {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.17912 0.37915V13.5796M13.9793 6.97936L0.378906 6.97936"
        stroke={color}
        strokeWidth="0.758333"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default PlusIcon;
